import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import { setupListeners } from "@reduxjs/toolkit/dist/query";

import * as authRedux from "./models/auth";
import * as commonRedux from "./models/common";
import * as filterRedux from "./models/filter";

import { baseApi } from "../api/baseApi";
import { rtkQueryErrorHandler } from "../api/error-handler";

export * from "../api/kiralasakApi";
export { authRedux, commonRedux, filterRedux };

/**
 * Sadece kalıcı olması gereken slice'lar diske yazılır.
 * RTK Query cache'i (baseApi.reducerPath) bilinçli olarak dışarıda:
 * eski cache'in rehydrate edilmesi bayat veri gösterir.
 */
const persistConfig = {
  key: "root",
  version: 1,
  whitelist: ["auth", "common"],
  storage: storage,
};

export const rootReducer = combineReducers({
  auth: authRedux.default,
  common: commonRedux.default,
  filter: filterRedux.default,
  [baseApi.reducerPath]: baseApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat([
      // kiralasakApi, baseApi'ye inject edildiği için aynı instance'tır;
      // middleware'i tek sefer eklemek gerekir.
      baseApi.middleware,
      rtkQueryErrorHandler,
    ]),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
